import { render, staticRenderFns } from "./TeacherAccessibleStudentPageList.vue?vue&type=template&id=281df6b0&"
import script from "./TeacherAccessibleStudentPageList.vue?vue&type=script&lang=ts&"
export * from "./TeacherAccessibleStudentPageList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports